// 原系統「靜態內容頁」的內容大綱 → 畫面用得動的節點序列。
//
// 與 legacy-forms / legacy-table-headers 同一套分法：
//   - legacy-content.generated.ts 是**資料**（由 scripts/extract-legacy-content.ts 產生，不手改）
//   - 這個檔是**規則**（哪些節點該畫、哪些是原系統的破版不該照抄）

import { LEGACY_CONTENT, type LegacyContentItem } from '@/mocks/legacy-content.generated';

export type { LegacyContentItem } from '@/mocks/legacy-content.generated';

/**
 * 全站頁尾文字（`div.footer` 的內容）。
 *
 * 【原系統缺陷 legacy-known-issue】`training-education-training-student` 的 JSP
 * （ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/educationTraining_student.jsp）
 * **少**一個 `</div>`：實測該檔 `<div` 出現 9 次、`</div>` 只有 8 次，內容區塊沒有收尾，
 * 於是瀏覽器把後面的全站頁尾 parse 成內容區的子節點，正規化之後成為內容區最後一個文字節點。
 * （對照組：同目錄的 educationTraining.jsp 是 15／15 平衡的，管理端那一頁就沒有這個症狀。）
 *
 * 全站 143 頁裡有 **2** 頁的頁尾落在 `.wrapper-content` 內：本頁與
 * `form-template-form-template`（formTemplate.jsp：`<div` 49／`</div>` 47，少兩個）。
 * 另外 141 頁的頁尾都在內容區外面。`form-template-form-template` 不是靜態內容頁、
 * 不走這條管線，所以這道閘門目前只在本頁生效（1/2）。
 *
 * 這是原系統的破版，不是這一頁的內容，**不照抄**——
 * React 的頁尾由 ApplicationShell 畫在內容區之外，位置才是對的。
 *
 * 依 REACT-UI-EXECUTION-PLAN.md §17 第 710 行，原系統可見的錯誤要「照實保留並標記
 * legacy-known-issue」；那一條講的是**錯字**（文字內容），不是把版型錯誤也複製一份。
 * 這裡選擇記錄而不複製，並在 structure diff 留下 1 筆可解釋的差異。
 */
export function isSiteFooterText(item: LegacyContentItem): boolean {
  return item.kind === 'text' && item.text.includes('版權所有') && item.text.includes('©');
}

/** pageId → 原系統該頁的靜態內容節點序列；不是靜態內容頁時 undefined。 */
export function legacyContentFor(pageId: string): readonly LegacyContentItem[] | undefined {
  const items = LEGACY_CONTENT[pageId];
  if (items === undefined) return undefined;
  const kept = items.filter((item) => !isSiteFooterText(item));
  return kept.length === 0 ? undefined : kept;
}
